import gql from 'graphql-tag';

export const GET_DELIVERY_TRACKING = gql`
    query GET_DELIVERY_TRACKING($deliveryId: ID!) {
        deliveryTracking(deliveryId: $deliveryId) {
            deliveryId
            state
            trackingUrl
            deliveryDate
            steps {
                kind
                reachedAt
            }
            plannedSlot {
                start
                end
            }
            estimatedSlot {
                start
                end
            }
            deliveredAt
            stopsBefore
            deliveryPersonName
            recipient {
                name
                contactName
                addressLines
            }
            photos {
                _id
                type
                url
            }
        }
    }
`;
